import { useMaskito } from "@maskito/react";
import {
  createPriceInputMask,
  extractNumberFromPriceInput,
} from "@greeter/maskito";
import { useEffect } from "react";

export function usePriceInput(props?: {
  initialValue?: number;
  onChange?: (n: number) => void;
}) {
  const opts = createPriceInputMask(props);
  return useMaskito({
    options: opts,
  });
}

export function usePriceInputListeners(
  el?: HTMLInputElement,
  opts?: { onChange?: (v: string) => void; onValueChange?: (v: number) => void }
) {
  useEffect(() => {
    if (!el) return;
    el.addEventListener("input", (ev) => {
      opts?.onChange?.((ev.currentTarget as HTMLInputElement).value);
      opts?.onValueChange?.(
        extractNumberFromPriceInput(
          (ev.currentTarget as HTMLInputElement).value
        )
      );
    });
  }, [el]);
}
